import { render, staticRenderFns } from "./SectionGallery.vue?vue&type=template&id=57806951"
import script from "./SectionGallery.vue?vue&type=script&lang=ts"
export * from "./SectionGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports